import { Eye, EyeOff } from 'lucide-react';
import { usePrivacyStore } from '@/stores/privacy';

/** Alterna ocultar/mostrar valores monetários no app inteiro. */
export function EyeToggle() {
  const hidden = usePrivacyStore((s) => s.hidden);
  const toggle = usePrivacyStore((s) => s.toggle);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={hidden ? 'Mostrar valores' : 'Ocultar valores'}
      className="grid size-11 place-items-center rounded-full text-muted transition-colors hover:bg-canvas lg:size-9"
    >
      {hidden ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
    </button>
  );
}
